export const getEventsForStudentQuery = (studentId: string, year: number) => {
    return `
query EventSearch {
    eventSearch(
        criteria: { studentId: "${studentId}", year: ${year} }
    ) {
        content {
            id
            school
            type
            title
            description
            venue
            calendarStartDate
            calendarEndDate
            status
            schoolCode
        }
    }
}
      `;
};

export const getEventsForStudentInTimeRangeQuery = (studentId: string, startDate: Date, endDate: Date) => {
    const pad = (n: number) => n.toString().padStart(2, '0');
    const formatDate = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

    const startDateString = formatDate(startDate);
    const endDateString = formatDate(endDate);

    return `
query EventSearch {
    eventSearch(
        criteria: { studentId: "${studentId}", startDate: "${startDateString}", endDate: "${endDateString}", year: 2025 }
    ) {
        content {
            id
            school
            type
            title
            description
            venue
            calendarStartDate
            calendarEndDate
            status
            schoolCode
        }
    }
}
      `;
};